import styled from '@emotion/styled';

export const Tag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.blackSecondary};
  background-color: ${({ theme }) => theme.colors.bgGrayLight};
  border: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
